// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAppClientInfoDto,
  IChangeUserLockingRequest,
  IChannelRequestDto,
  ICodeExchangeRequestDto,
  ICodeRequestDto,
  IConfirmSignUpRequestDto,
  IEmployeeRoleUpdateDto,
  IErrorDto,
  IForgotPasswordRequestDto,
  IForgotUsernameRequestDto,
  IGenericErrorDto,
  IGroupedPermissionsDto,
  IInitiateAuthRequestDto,
  IInitiateAuthResponseDto,
  IOrganizationPropertiesStateConfigRequestDto,
  IOrganizationPropertiesStateConfigResponseDto,
  IOrganizationPropertiesStatesDto,
  IPageLinkedApplicationUserResponseDto,
  IPageOrganizationPropertiesStateConfigResponseDto,
  IPageRoleResponseDto,
  IPasswordResetLinkValidationResponseDto,
  IResendConfirmationCodeRequestDto,
  IResendConfirmationCodeResponseDto,
  IRevokeTokenRequestDto,
  IRoleCreateDto,
  IRoleLiteDto,
  IRoleResponseDto,
  IRoleUpdateDto,
  IRolesAvailableForIdentityDto,
  ITokenRequestDto,
  ITokenResponseDto,
  IUnlockMfaDto,
  IUserChangePasswordDto,
  IUserConfirmForgotPasswordDto,
  IZendeskMessagingTokenResponseDto,
} from '../models/index';
import {
    IAppClientInfoDtoFromJSON,
    IAppClientInfoDtoToJSON,
    IChangeUserLockingRequestFromJSON,
    IChangeUserLockingRequestToJSON,
    IChannelRequestDtoFromJSON,
    IChannelRequestDtoToJSON,
    ICodeExchangeRequestDtoFromJSON,
    ICodeExchangeRequestDtoToJSON,
    ICodeRequestDtoFromJSON,
    ICodeRequestDtoToJSON,
    IConfirmSignUpRequestDtoFromJSON,
    IConfirmSignUpRequestDtoToJSON,
    IEmployeeRoleUpdateDtoFromJSON,
    IEmployeeRoleUpdateDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IForgotPasswordRequestDtoFromJSON,
    IForgotPasswordRequestDtoToJSON,
    IForgotUsernameRequestDtoFromJSON,
    IForgotUsernameRequestDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IGroupedPermissionsDtoFromJSON,
    IGroupedPermissionsDtoToJSON,
    IInitiateAuthRequestDtoFromJSON,
    IInitiateAuthRequestDtoToJSON,
    IInitiateAuthResponseDtoFromJSON,
    IInitiateAuthResponseDtoToJSON,
    IOrganizationPropertiesStateConfigRequestDtoFromJSON,
    IOrganizationPropertiesStateConfigRequestDtoToJSON,
    IOrganizationPropertiesStateConfigResponseDtoFromJSON,
    IOrganizationPropertiesStateConfigResponseDtoToJSON,
    IOrganizationPropertiesStatesDtoFromJSON,
    IOrganizationPropertiesStatesDtoToJSON,
    IPageLinkedApplicationUserResponseDtoFromJSON,
    IPageLinkedApplicationUserResponseDtoToJSON,
    IPageOrganizationPropertiesStateConfigResponseDtoFromJSON,
    IPageOrganizationPropertiesStateConfigResponseDtoToJSON,
    IPageRoleResponseDtoFromJSON,
    IPageRoleResponseDtoToJSON,
    IPasswordResetLinkValidationResponseDtoFromJSON,
    IPasswordResetLinkValidationResponseDtoToJSON,
    IResendConfirmationCodeRequestDtoFromJSON,
    IResendConfirmationCodeRequestDtoToJSON,
    IResendConfirmationCodeResponseDtoFromJSON,
    IResendConfirmationCodeResponseDtoToJSON,
    IRevokeTokenRequestDtoFromJSON,
    IRevokeTokenRequestDtoToJSON,
    IRoleCreateDtoFromJSON,
    IRoleCreateDtoToJSON,
    IRoleLiteDtoFromJSON,
    IRoleLiteDtoToJSON,
    IRoleResponseDtoFromJSON,
    IRoleResponseDtoToJSON,
    IRoleUpdateDtoFromJSON,
    IRoleUpdateDtoToJSON,
    IRolesAvailableForIdentityDtoFromJSON,
    IRolesAvailableForIdentityDtoToJSON,
    ITokenRequestDtoFromJSON,
    ITokenRequestDtoToJSON,
    ITokenResponseDtoFromJSON,
    ITokenResponseDtoToJSON,
    IUnlockMfaDtoFromJSON,
    IUnlockMfaDtoToJSON,
    IUserChangePasswordDtoFromJSON,
    IUserChangePasswordDtoToJSON,
    IUserConfirmForgotPasswordDtoFromJSON,
    IUserConfirmForgotPasswordDtoToJSON,
    IZendeskMessagingTokenResponseDtoFromJSON,
    IZendeskMessagingTokenResponseDtoToJSON,
} from '../models/index';

export interface AuthForgotUsernameRequest {
    iForgotUsernameRequestDto: IForgotUsernameRequestDto;
    userAgent?: string;
}

export interface ChangePasswordRequest {
    iUserChangePasswordDto: IUserChangePasswordDto;
    userAgent?: string;
}

export interface ConfirmForgotPasswordRequest {
    iUserConfirmForgotPasswordDto: IUserConfirmForgotPasswordDto;
    linkId?: number;
    userAgent?: string;
}

export interface CreateAppClientRequest {
    iAppClientInfoDto: IAppClientInfoDto;
}

export interface CreateOrganizationPropertiesStateConfigRequest {
    iOrganizationPropertiesStateConfigRequestDto: IOrganizationPropertiesStateConfigRequestDto;
}

export interface CreateRoleRequest {
    iRoleCreateDto: IRoleCreateDto;
}

export interface DeleteUserRequest {
    username: string;
}

export interface ExchangeCodeRequest {
    iCodeExchangeRequestDto: ICodeExchangeRequestDto;
}

export interface ForgotPasswordRequest {
    iForgotPasswordRequestDto: IForgotPasswordRequestDto;
    userAgent?: string;
}

export interface ForgotPasswordOutdatedRequest {
    iForgotPasswordRequestDto: IForgotPasswordRequestDto;
}

export interface GenerateContactMfaCodeRequest {
    iChannelRequestDto: IChannelRequestDto;
}

export interface GenerateContactVerificationCodeRequest {
    iChannelRequestDto: IChannelRequestDto;
}

export interface GenerateMfaCodeRequest {
    iChannelRequestDto: IChannelRequestDto;
}

export interface GetAppClientRequest {
    clientId: string;
}

export interface GetByIdRequest {
    id: number;
}

export interface GetLinkedApplicationUsersRequest {
    linkId: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetRoleRequest {
    id: number;
}

export interface GetRoleIdsByPermissionRequest {
    permissionId: number;
}

export interface GetRolesForIdentityRequest {
    grantedPermissionIds?: Set<number>;
}

export interface GustoAuthorizeCognitoRequest {
    code?: string;
    state?: string;
    error?: string;
    errorDescription?: string;
    loginHint?: string;
    scope?: string;
    clientId?: string;
}

export interface LockUserRequest {
    username: string;
}

export interface LockUserLoginRequest {
    iChangeUserLockingRequest: IChangeUserLockingRequest;
}

export interface RefreshTokenRequest {
    iTokenRequestDto: ITokenRequestDto;
}

export interface RefreshToken1Request {
    iTokenRequestDto: ITokenRequestDto;
}

export interface RemoveAppClientRequest {
    clientId: string;
}

export interface ResendConfirmationCodeRequest {
    iResendConfirmationCodeRequestDto: IResendConfirmationCodeRequestDto;
}

export interface RevokeTokenRequest {
    iRevokeTokenRequestDto: IRevokeTokenRequestDto;
}

export interface SearchConfigsRequest {
    searchValue?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchLoginHistoryAdminRequest {
    contactId: number;
    startDate?: Date;
    endDate?: Date;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchLoginHistoryEmployeeRequest {
    employeeIds: Array<number>;
    startDate?: Date;
    endDate?: Date;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchRolesByPagesRequest {
    searchValue?: string;
    levelType?: SearchRolesByPagesLevelTypeEnum;
    organizationIds?: Set<number>;
    permissionIds?: Set<number>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SignInApplicationUserRequest {
    iInitiateAuthRequestDto: IInitiateAuthRequestDto;
    userAgent?: string;
}

export interface SignInApplicationUser1Request {
    iInitiateAuthRequestDto: IInitiateAuthRequestDto;
    userAgent?: string;
}

export interface SignUpConfirmationUserRequest {
    iConfirmSignUpRequestDto: IConfirmSignUpRequestDto;
}

export interface UnlockMfaRequest {
    iUnlockMfaDto: IUnlockMfaDto;
}

export interface UnlockUserRequest {
    username: string;
}

export interface UnlockUserLoginRequest {
    iChangeUserLockingRequest: IChangeUserLockingRequest;
}

export interface UpdateApplicationUserRole1Request {
    iEmployeeRoleUpdateDto: IEmployeeRoleUpdateDto;
}

export interface UpdateOrganizationPropertiesStateConfigRequest {
    id: number;
    iOrganizationPropertiesStateConfigRequestDto: IOrganizationPropertiesStateConfigRequestDto;
}

export interface UpdateRoleRequest {
    id: number;
    iRoleUpdateDto: IRoleUpdateDto;
}

export interface ValidatePasswordResetLinkRequest {
    linkId: number;
    userAgent?: string;
}

export interface VerifyContactCodeRequest {
    iCodeRequestDto: ICodeRequestDto;
}

export interface VerifyContactMfaCodeRequest {
    iCodeRequestDto: ICodeRequestDto;
    userAgent?: string;
}

export interface VerifyPersonMfaCodeRequest {
    iCodeRequestDto: ICodeRequestDto;
    userAgent?: string;
}

/**
 * AuthServiceServiceApi - interface
 * 
 * @export
 * @interface AuthServiceServiceApiInterface
 */
export interface AuthServiceServiceApiInterface {
    /**
     * 
     * @param {IForgotUsernameRequestDto} iForgotUsernameRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    authForgotUsernameRaw(requestParameters: AuthForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    authForgotUsername(requestParameters: AuthForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IUserChangePasswordDto} iUserChangePasswordDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    changePassword(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IUserConfirmForgotPasswordDto} iUserConfirmForgotPasswordDto 
     * @param {number} [linkId] Provide link_id in the request body instead.
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    confirmForgotPasswordRaw(requestParameters: ConfirmForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    confirmForgotPassword(requestParameters: ConfirmForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IAppClientInfoDto} iAppClientInfoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    createAppClientRaw(requestParameters: CreateAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAppClientInfoDto>>;

    /**
     */
    createAppClient(requestParameters: CreateAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAppClientInfoDto>;

    /**
     * 
     * @summary Create new OrganizationPropertiesStateConfig
     * @param {IOrganizationPropertiesStateConfigRequestDto} iOrganizationPropertiesStateConfigRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    createOrganizationPropertiesStateConfigRaw(requestParameters: CreateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStateConfigResponseDto>>;

    /**
     * Create new OrganizationPropertiesStateConfig
     */
    createOrganizationPropertiesStateConfig(requestParameters: CreateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStateConfigResponseDto>;

    /**
     * 
     * @summary Create new role
     * @param {IRoleCreateDto} iRoleCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    createRoleRaw(requestParameters: CreateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRoleResponseDto>>;

    /**
     * Create new role
     */
    createRole(requestParameters: CreateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRoleResponseDto>;

    /**
     * 
     * @summary Remove participant credentials (application user and Cognito user) by username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove participant credentials (application user and Cognito user) by username
     */
    deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {ICodeExchangeRequestDto} iCodeExchangeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    exchangeCodeRaw(requestParameters: ExchangeCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    exchangeCode(requestParameters: ExchangeCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IForgotPasswordRequestDto} iForgotPasswordRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    forgotPasswordRaw(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    forgotPassword(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IForgotPasswordRequestDto} iForgotPasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    forgotPasswordOutdatedRaw(requestParameters: ForgotPasswordOutdatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * @deprecated
     */
    forgotPasswordOutdated(requestParameters: ForgotPasswordOutdatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IChannelRequestDto} iChannelRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    generateContactMfaCodeRaw(requestParameters: GenerateContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    generateContactMfaCode(requestParameters: GenerateContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IChannelRequestDto} iChannelRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    generateContactVerificationCodeRaw(requestParameters: GenerateContactVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    generateContactVerificationCode(requestParameters: GenerateContactVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IChannelRequestDto} iChannelRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    generateMfaCodeRaw(requestParameters: GenerateMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    generateMfaCode(requestParameters: GenerateMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getAllPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: IGroupedPermissionsDto; }>>;

    /**
     * Get permissions
     */
    getAllPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: IGroupedPermissionsDto; }>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getAppClientRaw(requestParameters: GetAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAppClientInfoDto>>;

    /**
     */
    getAppClient(requestParameters: GetAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAppClientInfoDto>;

    /**
     * 
     * @summary Get OrganizationPropertiesStateConfig by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getByIdRaw(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStateConfigResponseDto>>;

    /**
     * Get OrganizationPropertiesStateConfig by id
     */
    getById(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStateConfigResponseDto>;

    /**
     * 
     * @summary Get states for all organization properties for current user\'s role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getCurrentUserOrganizationPropertiesStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStatesDto>>;

    /**
     * Get states for all organization properties for current user\'s role
     */
    getCurrentUserOrganizationPropertiesStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStatesDto>;

    /**
     * 
     * @summary Get permissions for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getCurrentUserPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<string>>>;

    /**
     * Get permissions for current user
     */
    getCurrentUserPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<string>>;

    /**
     * 
     * @summary Get linked application users by link id
     * @param {string} linkId 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getLinkedApplicationUsersRaw(requestParameters: GetLinkedApplicationUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageLinkedApplicationUserResponseDto>>;

    /**
     * Get linked application users by link id
     */
    getLinkedApplicationUsers(requestParameters: GetLinkedApplicationUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageLinkedApplicationUserResponseDto>;

    /**
     * 
     * @summary Get role by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getRoleRaw(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRoleResponseDto>>;

    /**
     * Get role by id
     */
    getRole(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRoleResponseDto>;

    /**
     * 
     * @summary Get role IDs by permission
     * @param {number} permissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getRoleIdsByPermissionRaw(requestParameters: GetRoleIdsByPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<IRoleLiteDto>>>;

    /**
     * Get role IDs by permission
     */
    getRoleIdsByPermission(requestParameters: GetRoleIdsByPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<IRoleLiteDto>>;

    /**
     * 
     * @summary Get roles allowed for creation by identity role
     * @param {Set<number>} [grantedPermissionIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    getRolesForIdentityRaw(requestParameters: GetRolesForIdentityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRolesAvailableForIdentityDto>>;

    /**
     * Get roles allowed for creation by identity role
     */
    getRolesForIdentity(requestParameters: GetRolesForIdentityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRolesAvailableForIdentityDto>;

    /**
     * Handles SSO authorization redirect from OAuth providers
     * @param {string} [code] Authorization code
     * @param {string} [state] State parameter
     * @param {string} [error] Error code
     * @param {string} [errorDescription] Error description
     * @param {string} [loginHint] Login hint
     * @param {string} [scope] OAuth scope
     * @param {string} [clientId] Client ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    gustoAuthorizeCognitoRaw(requestParameters: GustoAuthorizeCognitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Handles SSO authorization redirect from OAuth providers
     */
    gustoAuthorizeCognito(requestParameters: GustoAuthorizeCognitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Issue signed JWT for Zendesk Messaging widget authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    issueMessagingTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IZendeskMessagingTokenResponseDto>>;

    /**
     * Issue signed JWT for Zendesk Messaging widget authentication
     */
    issueMessagingToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IZendeskMessagingTokenResponseDto>;

    /**
     * 
     * @summary Lock an application user by username (sets active = false)
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    lockUserRaw(requestParameters: LockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Lock an application user by username (sets active = false)
     */
    lockUser(requestParameters: LockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Deprecated. Use POST /application-user/{username}/lock instead.
     * @param {IChangeUserLockingRequest} iChangeUserLockingRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    lockUserLoginRaw(requestParameters: LockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deprecated. Use POST /application-user/{username}/lock instead.
     * @deprecated
     */
    lockUserLogin(requestParameters: LockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {ITokenRequestDto} iTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    refreshTokenRaw(requestParameters: RefreshTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITokenResponseDto>>;

    /**
     */
    refreshToken(requestParameters: RefreshTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITokenResponseDto>;

    /**
     * 
     * @param {ITokenRequestDto} iTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    refreshToken1Raw(requestParameters: RefreshToken1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITokenResponseDto>>;

    /**
     */
    refreshToken1(requestParameters: RefreshToken1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITokenResponseDto>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    removeAppClientRaw(requestParameters: RemoveAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    removeAppClient(requestParameters: RemoveAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Resend Cognito sign-up confirmation code
     * @param {IResendConfirmationCodeRequestDto} iResendConfirmationCodeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    resendConfirmationCodeRaw(requestParameters: ResendConfirmationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IResendConfirmationCodeResponseDto>>;

    /**
     * Resend Cognito sign-up confirmation code
     */
    resendConfirmationCode(requestParameters: ResendConfirmationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IResendConfirmationCodeResponseDto | null | undefined >;

    /**
     * 
     * @param {IRevokeTokenRequestDto} iRevokeTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    revokeTokenRaw(requestParameters: RevokeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    revokeToken(requestParameters: RevokeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get OrganizationPropertiesStateConfigs by search params
     * @param {string} [searchValue] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    searchConfigsRaw(requestParameters: SearchConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageOrganizationPropertiesStateConfigResponseDto>>;

    /**
     * Get OrganizationPropertiesStateConfigs by search params
     */
    searchConfigs(requestParameters: SearchConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageOrganizationPropertiesStateConfigResponseDto>;

    /**
     * 
     * @param {number} contactId 
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    searchLoginHistoryAdminRaw(requestParameters: SearchLoginHistoryAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    searchLoginHistoryAdmin(requestParameters: SearchLoginHistoryAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {Array<number>} employeeIds 
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    searchLoginHistoryEmployeeRaw(requestParameters: SearchLoginHistoryEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    searchLoginHistoryEmployee(requestParameters: SearchLoginHistoryEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get roles by search params
     * @param {string} [searchValue] 
     * @param {'ELEVATE' | 'GLOBAL' | 'PARTNER'} [levelType] 
     * @param {Set<number>} [organizationIds] 
     * @param {Set<number>} [permissionIds] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    searchRolesByPagesRaw(requestParameters: SearchRolesByPagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageRoleResponseDto>>;

    /**
     * Get roles by search params
     */
    searchRolesByPages(requestParameters: SearchRolesByPagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageRoleResponseDto>;

    /**
     * 
     * @param {IInitiateAuthRequestDto} iInitiateAuthRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    signInApplicationUserRaw(requestParameters: SignInApplicationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>>;

    /**
     */
    signInApplicationUser(requestParameters: SignInApplicationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto>;

    /**
     * 
     * @param {IInitiateAuthRequestDto} iInitiateAuthRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    signInApplicationUser1Raw(requestParameters: SignInApplicationUser1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>>;

    /**
     */
    signInApplicationUser1(requestParameters: SignInApplicationUser1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto>;

    /**
     * 
     * @summary Confirm user sign-up in Cognito
     * @param {IConfirmSignUpRequestDto} iConfirmSignUpRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    signUpConfirmationUserRaw(requestParameters: SignUpConfirmationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IConfirmSignUpRequestDto>>;

    /**
     * Confirm user sign-up in Cognito
     */
    signUpConfirmationUser(requestParameters: SignUpConfirmationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IConfirmSignUpRequestDto>;

    /**
     * 
     * @param {IUnlockMfaDto} iUnlockMfaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    unlockMfaRaw(requestParameters: UnlockMfaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    unlockMfa(requestParameters: UnlockMfaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Unlock an application user by username (sets active = true)
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    unlockUserRaw(requestParameters: UnlockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlock an application user by username (sets active = true)
     */
    unlockUser(requestParameters: UnlockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Deprecated. Use POST /application-user/{username}/unlock instead.
     * @param {IChangeUserLockingRequest} iChangeUserLockingRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    unlockUserLoginRaw(requestParameters: UnlockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deprecated. Use POST /application-user/{username}/unlock instead.
     * @deprecated
     */
    unlockUserLogin(requestParameters: UnlockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {IEmployeeRoleUpdateDto} iEmployeeRoleUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    updateApplicationUserRole1Raw(requestParameters: UpdateApplicationUserRole1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateApplicationUserRole1(requestParameters: UpdateApplicationUserRole1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update OrganizationPropertiesStateConfig
     * @param {number} id 
     * @param {IOrganizationPropertiesStateConfigRequestDto} iOrganizationPropertiesStateConfigRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    updateOrganizationPropertiesStateConfigRaw(requestParameters: UpdateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStateConfigResponseDto>>;

    /**
     * Update OrganizationPropertiesStateConfig
     */
    updateOrganizationPropertiesStateConfig(requestParameters: UpdateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStateConfigResponseDto>;

    /**
     * 
     * @summary Update role
     * @param {number} id 
     * @param {IRoleUpdateDto} iRoleUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    updateRoleRaw(requestParameters: UpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRoleResponseDto>>;

    /**
     * Update role
     */
    updateRole(requestParameters: UpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRoleResponseDto>;

    /**
     * 
     * @param {number} linkId 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    validatePasswordResetLinkRaw(requestParameters: ValidatePasswordResetLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPasswordResetLinkValidationResponseDto>>;

    /**
     */
    validatePasswordResetLink(requestParameters: ValidatePasswordResetLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPasswordResetLinkValidationResponseDto>;

    /**
     * 
     * @param {ICodeRequestDto} iCodeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    verifyContactCodeRaw(requestParameters: VerifyContactCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>>;

    /**
     */
    verifyContactCode(requestParameters: VerifyContactCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto>;

    /**
     * 
     * @param {ICodeRequestDto} iCodeRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    verifyContactMfaCodeRaw(requestParameters: VerifyContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>>;

    /**
     */
    verifyContactMfaCode(requestParameters: VerifyContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto>;

    /**
     * 
     * @param {ICodeRequestDto} iCodeRequestDto 
     * @param {string} [userAgent] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceServiceApiInterface
     */
    verifyPersonMfaCodeRaw(requestParameters: VerifyPersonMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>>;

    /**
     */
    verifyPersonMfaCode(requestParameters: VerifyPersonMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto>;

}

/**
 * 
 */
export class AuthServiceServiceApi extends runtime.BaseAPI implements AuthServiceServiceApiInterface {

    /**
     */
    async authForgotUsernameRaw(requestParameters: AuthForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iForgotUsernameRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iForgotUsernameRequestDto',
                'Required parameter "iForgotUsernameRequestDto" was null or undefined when calling authForgotUsername().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/contacts/usernames/forgot`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IForgotUsernameRequestDtoToJSON(requestParameters['iForgotUsernameRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authForgotUsername(requestParameters: AuthForgotUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authForgotUsernameRaw(requestParameters, initOverrides);
    }

    /**
     */
    async changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iUserChangePasswordDto'] == null) {
            throw new runtime.RequiredError(
                'iUserChangePasswordDto',
                'Required parameter "iUserChangePasswordDto" was null or undefined when calling changePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/passwords`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IUserChangePasswordDtoToJSON(requestParameters['iUserChangePasswordDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async changePassword(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changePasswordRaw(requestParameters, initOverrides);
    }

    /**
     */
    async confirmForgotPasswordRaw(requestParameters: ConfirmForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iUserConfirmForgotPasswordDto'] == null) {
            throw new runtime.RequiredError(
                'iUserConfirmForgotPasswordDto',
                'Required parameter "iUserConfirmForgotPasswordDto" was null or undefined when calling confirmForgotPassword().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['linkId'] != null) {
            queryParameters['link_id'] = requestParameters['linkId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/passwords/reset`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IUserConfirmForgotPasswordDtoToJSON(requestParameters['iUserConfirmForgotPasswordDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async confirmForgotPassword(requestParameters: ConfirmForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmForgotPasswordRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createAppClientRaw(requestParameters: CreateAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAppClientInfoDto>> {
        if (requestParameters['iAppClientInfoDto'] == null) {
            throw new runtime.RequiredError(
                'iAppClientInfoDto',
                'Required parameter "iAppClientInfoDto" was null or undefined when calling createAppClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-clients`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IAppClientInfoDtoToJSON(requestParameters['iAppClientInfoDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAppClientInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async createAppClient(requestParameters: CreateAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAppClientInfoDto> {
        const response = await this.createAppClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new OrganizationPropertiesStateConfig
     */
    async createOrganizationPropertiesStateConfigRaw(requestParameters: CreateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStateConfigResponseDto>> {
        if (requestParameters['iOrganizationPropertiesStateConfigRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationPropertiesStateConfigRequestDto',
                'Required parameter "iOrganizationPropertiesStateConfigRequestDto" was null or undefined when calling createOrganizationPropertiesStateConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-properties-state-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationPropertiesStateConfigRequestDtoToJSON(requestParameters['iOrganizationPropertiesStateConfigRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPropertiesStateConfigResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create new OrganizationPropertiesStateConfig
     */
    async createOrganizationPropertiesStateConfig(requestParameters: CreateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStateConfigResponseDto> {
        const response = await this.createOrganizationPropertiesStateConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new role
     */
    async createRoleRaw(requestParameters: CreateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRoleResponseDto>> {
        if (requestParameters['iRoleCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iRoleCreateDto',
                'Required parameter "iRoleCreateDto" was null or undefined when calling createRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/roles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IRoleCreateDtoToJSON(requestParameters['iRoleCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRoleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create new role
     */
    async createRole(requestParameters: CreateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRoleResponseDto> {
        const response = await this.createRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove participant credentials (application user and Cognito user) by username
     */
    async deleteUserRaw(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling deleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/application-user/{username}`;
        urlPath = urlPath.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters['username'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove participant credentials (application user and Cognito user) by username
     */
    async deleteUser(requestParameters: DeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exchangeCodeRaw(requestParameters: ExchangeCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iCodeExchangeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCodeExchangeRequestDto',
                'Required parameter "iCodeExchangeRequestDto" was null or undefined when calling exchangeCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/oauth2/token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICodeExchangeRequestDtoToJSON(requestParameters['iCodeExchangeRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async exchangeCode(requestParameters: ExchangeCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.exchangeCodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async forgotPasswordRaw(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iForgotPasswordRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iForgotPasswordRequestDto',
                'Required parameter "iForgotPasswordRequestDto" was null or undefined when calling forgotPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/forgot-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IForgotPasswordRequestDtoToJSON(requestParameters['iForgotPasswordRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async forgotPassword(requestParameters: ForgotPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.forgotPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * @deprecated
     */
    async forgotPasswordOutdatedRaw(requestParameters: ForgotPasswordOutdatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iForgotPasswordRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iForgotPasswordRequestDto',
                'Required parameter "iForgotPasswordRequestDto" was null or undefined when calling forgotPasswordOutdated().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/persons/forgot-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IForgotPasswordRequestDtoToJSON(requestParameters['iForgotPasswordRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * @deprecated
     */
    async forgotPasswordOutdated(requestParameters: ForgotPasswordOutdatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.forgotPasswordOutdatedRaw(requestParameters, initOverrides);
    }

    /**
     */
    async generateContactMfaCodeRaw(requestParameters: GenerateContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iChannelRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iChannelRequestDto',
                'Required parameter "iChannelRequestDto" was null or undefined when calling generateContactMfaCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/contacts/mfa/codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IChannelRequestDtoToJSON(requestParameters['iChannelRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async generateContactMfaCode(requestParameters: GenerateContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.generateContactMfaCodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async generateContactVerificationCodeRaw(requestParameters: GenerateContactVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iChannelRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iChannelRequestDto',
                'Required parameter "iChannelRequestDto" was null or undefined when calling generateContactVerificationCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/contacts/codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IChannelRequestDtoToJSON(requestParameters['iChannelRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async generateContactVerificationCode(requestParameters: GenerateContactVerificationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.generateContactVerificationCodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async generateMfaCodeRaw(requestParameters: GenerateMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iChannelRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iChannelRequestDto',
                'Required parameter "iChannelRequestDto" was null or undefined when calling generateMfaCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/mfa/codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IChannelRequestDtoToJSON(requestParameters['iChannelRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async generateMfaCode(requestParameters: GenerateMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.generateMfaCodeRaw(requestParameters, initOverrides);
    }

    /**
     * Get permissions
     */
    async getAllPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: IGroupedPermissionsDto; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/permissions/all`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, IGroupedPermissionsDtoFromJSON));
    }

    /**
     * Get permissions
     */
    async getAllPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: IGroupedPermissionsDto; }> {
        const response = await this.getAllPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAppClientRaw(requestParameters: GetAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAppClientInfoDto>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getAppClient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-clients`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAppClientInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getAppClient(requestParameters: GetAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAppClientInfoDto> {
        const response = await this.getAppClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get OrganizationPropertiesStateConfig by id
     */
    async getByIdRaw(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStateConfigResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-properties-state-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPropertiesStateConfigResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get OrganizationPropertiesStateConfig by id
     */
    async getById(requestParameters: GetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStateConfigResponseDto> {
        const response = await this.getByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get states for all organization properties for current user\'s role
     */
    async getCurrentUserOrganizationPropertiesStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStatesDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-properties-states`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPropertiesStatesDtoFromJSON(jsonValue));
    }

    /**
     * Get states for all organization properties for current user\'s role
     */
    async getCurrentUserOrganizationPropertiesStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStatesDto> {
        const response = await this.getCurrentUserOrganizationPropertiesStatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get permissions for current user
     */
    async getCurrentUserPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/permissions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get permissions for current user
     */
    async getCurrentUserPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<string>> {
        const response = await this.getCurrentUserPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get linked application users by link id
     */
    async getLinkedApplicationUsersRaw(requestParameters: GetLinkedApplicationUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageLinkedApplicationUserResponseDto>> {
        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling getLinkedApplicationUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/application-users/linked/{link-id}`;
        urlPath = urlPath.replace(`{${"link-id"}}`, encodeURIComponent(String(requestParameters['linkId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageLinkedApplicationUserResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get linked application users by link id
     */
    async getLinkedApplicationUsers(requestParameters: GetLinkedApplicationUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageLinkedApplicationUserResponseDto> {
        const response = await this.getLinkedApplicationUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get role by id
     */
    async getRoleRaw(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRoleResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/roles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRoleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get role by id
     */
    async getRole(requestParameters: GetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRoleResponseDto> {
        const response = await this.getRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get role IDs by permission
     */
    async getRoleIdsByPermissionRaw(requestParameters: GetRoleIdsByPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<IRoleLiteDto>>> {
        if (requestParameters['permissionId'] == null) {
            throw new runtime.RequiredError(
                'permissionId',
                'Required parameter "permissionId" was null or undefined when calling getRoleIdsByPermission().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['permissionId'] != null) {
            queryParameters['permission_id'] = requestParameters['permissionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/roles/by-permission`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => new Set(jsonValue.map(IRoleLiteDtoFromJSON)));
    }

    /**
     * Get role IDs by permission
     */
    async getRoleIdsByPermission(requestParameters: GetRoleIdsByPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<IRoleLiteDto>> {
        const response = await this.getRoleIdsByPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get roles allowed for creation by identity role
     */
    async getRolesForIdentityRaw(requestParameters: GetRolesForIdentityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRolesAvailableForIdentityDto>> {
        const queryParameters: any = {};

        if (requestParameters['grantedPermissionIds'] != null) {
            queryParameters['granted_permission_ids'] = requestParameters['grantedPermissionIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/roles/user-and-organization`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRolesAvailableForIdentityDtoFromJSON(jsonValue));
    }

    /**
     * Get roles allowed for creation by identity role
     */
    async getRolesForIdentity(requestParameters: GetRolesForIdentityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRolesAvailableForIdentityDto> {
        const response = await this.getRolesForIdentityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Handles SSO authorization redirect from OAuth providers
     */
    async gustoAuthorizeCognitoRaw(requestParameters: GustoAuthorizeCognitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        if (requestParameters['errorDescription'] != null) {
            queryParameters['error_description'] = requestParameters['errorDescription'];
        }

        if (requestParameters['loginHint'] != null) {
            queryParameters['login_hint'] = requestParameters['loginHint'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/signin/sso`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Handles SSO authorization redirect from OAuth providers
     */
    async gustoAuthorizeCognito(requestParameters: GustoAuthorizeCognitoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.gustoAuthorizeCognitoRaw(requestParameters, initOverrides);
    }

    /**
     * Issue signed JWT for Zendesk Messaging widget authentication
     */
    async issueMessagingTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IZendeskMessagingTokenResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/zendesk/messaging-token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IZendeskMessagingTokenResponseDtoFromJSON(jsonValue));
    }

    /**
     * Issue signed JWT for Zendesk Messaging widget authentication
     */
    async issueMessagingToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IZendeskMessagingTokenResponseDto> {
        const response = await this.issueMessagingTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Lock an application user by username (sets active = false)
     */
    async lockUserRaw(requestParameters: LockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling lockUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/application-user/{username}/lock`;
        urlPath = urlPath.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters['username'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Lock an application user by username (sets active = false)
     */
    async lockUser(requestParameters: LockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.lockUserRaw(requestParameters, initOverrides);
    }

    /**
     * Deprecated. Use POST /application-user/{username}/lock instead.
     * @deprecated
     */
    async lockUserLoginRaw(requestParameters: LockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iChangeUserLockingRequest'] == null) {
            throw new runtime.RequiredError(
                'iChangeUserLockingRequest',
                'Required parameter "iChangeUserLockingRequest" was null or undefined when calling lockUserLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login/lock`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IChangeUserLockingRequestToJSON(requestParameters['iChangeUserLockingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deprecated. Use POST /application-user/{username}/lock instead.
     * @deprecated
     */
    async lockUserLogin(requestParameters: LockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.lockUserLoginRaw(requestParameters, initOverrides);
    }

    /**
     */
    async refreshTokenRaw(requestParameters: RefreshTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITokenResponseDto>> {
        if (requestParameters['iTokenRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iTokenRequestDto',
                'Required parameter "iTokenRequestDto" was null or undefined when calling refreshToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/refresh`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ITokenRequestDtoToJSON(requestParameters['iTokenRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ITokenResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async refreshToken(requestParameters: RefreshTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITokenResponseDto> {
        const response = await this.refreshTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async refreshToken1Raw(requestParameters: RefreshToken1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITokenResponseDto>> {
        if (requestParameters['iTokenRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iTokenRequestDto',
                'Required parameter "iTokenRequestDto" was null or undefined when calling refreshToken1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/contacts/refresh`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ITokenRequestDtoToJSON(requestParameters['iTokenRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ITokenResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async refreshToken1(requestParameters: RefreshToken1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITokenResponseDto> {
        const response = await this.refreshToken1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeAppClientRaw(requestParameters: RemoveAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling removeAppClient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/app-clients`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeAppClient(requestParameters: RemoveAppClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeAppClientRaw(requestParameters, initOverrides);
    }

    /**
     * Resend Cognito sign-up confirmation code
     */
    async resendConfirmationCodeRaw(requestParameters: ResendConfirmationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IResendConfirmationCodeResponseDto>> {
        if (requestParameters['iResendConfirmationCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iResendConfirmationCodeRequestDto',
                'Required parameter "iResendConfirmationCodeRequestDto" was null or undefined when calling resendConfirmationCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/resend-confirmation-code`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IResendConfirmationCodeRequestDtoToJSON(requestParameters['iResendConfirmationCodeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IResendConfirmationCodeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Resend Cognito sign-up confirmation code
     */
    async resendConfirmationCode(requestParameters: ResendConfirmationCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IResendConfirmationCodeResponseDto | null | undefined > {
        const response = await this.resendConfirmationCodeRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 204:
                return null;
            case 201:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     */
    async revokeTokenRaw(requestParameters: RevokeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iRevokeTokenRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iRevokeTokenRequestDto',
                'Required parameter "iRevokeTokenRequestDto" was null or undefined when calling revokeToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/revoke`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IRevokeTokenRequestDtoToJSON(requestParameters['iRevokeTokenRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async revokeToken(requestParameters: RevokeTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Get OrganizationPropertiesStateConfigs by search params
     */
    async searchConfigsRaw(requestParameters: SearchConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageOrganizationPropertiesStateConfigResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-properties-state-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageOrganizationPropertiesStateConfigResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get OrganizationPropertiesStateConfigs by search params
     */
    async searchConfigs(requestParameters: SearchConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageOrganizationPropertiesStateConfigResponseDto> {
        const response = await this.searchConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchLoginHistoryAdminRaw(requestParameters: SearchLoginHistoryAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling searchLoginHistoryAdmin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contactId'] != null) {
            queryParameters['contact_id'] = requestParameters['contactId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login-history/admin`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async searchLoginHistoryAdmin(requestParameters: SearchLoginHistoryAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.searchLoginHistoryAdminRaw(requestParameters, initOverrides);
    }

    /**
     */
    async searchLoginHistoryEmployeeRaw(requestParameters: SearchLoginHistoryEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeIds'] == null) {
            throw new runtime.RequiredError(
                'employeeIds',
                'Required parameter "employeeIds" was null or undefined when calling searchLoginHistoryEmployee().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString();
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login-history/employee`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async searchLoginHistoryEmployee(requestParameters: SearchLoginHistoryEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.searchLoginHistoryEmployeeRaw(requestParameters, initOverrides);
    }

    /**
     * Get roles by search params
     */
    async searchRolesByPagesRaw(requestParameters: SearchRolesByPagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageRoleResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['levelType'] != null) {
            queryParameters['level_type'] = requestParameters['levelType'];
        }

        if (requestParameters['organizationIds'] != null) {
            queryParameters['organization_ids'] = requestParameters['organizationIds'];
        }

        if (requestParameters['permissionIds'] != null) {
            queryParameters['permission_ids'] = requestParameters['permissionIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/roles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageRoleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get roles by search params
     */
    async searchRolesByPages(requestParameters: SearchRolesByPagesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageRoleResponseDto> {
        const response = await this.searchRolesByPagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async signInApplicationUserRaw(requestParameters: SignInApplicationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>> {
        if (requestParameters['iInitiateAuthRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iInitiateAuthRequestDto',
                'Required parameter "iInitiateAuthRequestDto" was null or undefined when calling signInApplicationUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/signin`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IInitiateAuthRequestDtoToJSON(requestParameters['iInitiateAuthRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInitiateAuthResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async signInApplicationUser(requestParameters: SignInApplicationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto> {
        const response = await this.signInApplicationUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async signInApplicationUser1Raw(requestParameters: SignInApplicationUser1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>> {
        if (requestParameters['iInitiateAuthRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iInitiateAuthRequestDto',
                'Required parameter "iInitiateAuthRequestDto" was null or undefined when calling signInApplicationUser1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/contacts/signin`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IInitiateAuthRequestDtoToJSON(requestParameters['iInitiateAuthRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInitiateAuthResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async signInApplicationUser1(requestParameters: SignInApplicationUser1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto> {
        const response = await this.signInApplicationUser1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm user sign-up in Cognito
     */
    async signUpConfirmationUserRaw(requestParameters: SignUpConfirmationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IConfirmSignUpRequestDto>> {
        if (requestParameters['iConfirmSignUpRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iConfirmSignUpRequestDto',
                'Required parameter "iConfirmSignUpRequestDto" was null or undefined when calling signUpConfirmationUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/sign-up/confirmation`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IConfirmSignUpRequestDtoToJSON(requestParameters['iConfirmSignUpRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IConfirmSignUpRequestDtoFromJSON(jsonValue));
    }

    /**
     * Confirm user sign-up in Cognito
     */
    async signUpConfirmationUser(requestParameters: SignUpConfirmationUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IConfirmSignUpRequestDto> {
        const response = await this.signUpConfirmationUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async unlockMfaRaw(requestParameters: UnlockMfaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iUnlockMfaDto'] == null) {
            throw new runtime.RequiredError(
                'iUnlockMfaDto',
                'Required parameter "iUnlockMfaDto" was null or undefined when calling unlockMfa().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/mfa/unlock`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IUnlockMfaDtoToJSON(requestParameters['iUnlockMfaDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async unlockMfa(requestParameters: UnlockMfaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlockMfaRaw(requestParameters, initOverrides);
    }

    /**
     * Unlock an application user by username (sets active = true)
     */
    async unlockUserRaw(requestParameters: UnlockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['username'] == null) {
            throw new runtime.RequiredError(
                'username',
                'Required parameter "username" was null or undefined when calling unlockUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/application-user/{username}/unlock`;
        urlPath = urlPath.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters['username'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlock an application user by username (sets active = true)
     */
    async unlockUser(requestParameters: UnlockUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlockUserRaw(requestParameters, initOverrides);
    }

    /**
     * Deprecated. Use POST /application-user/{username}/unlock instead.
     * @deprecated
     */
    async unlockUserLoginRaw(requestParameters: UnlockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iChangeUserLockingRequest'] == null) {
            throw new runtime.RequiredError(
                'iChangeUserLockingRequest',
                'Required parameter "iChangeUserLockingRequest" was null or undefined when calling unlockUserLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/login/unlock`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IChangeUserLockingRequestToJSON(requestParameters['iChangeUserLockingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deprecated. Use POST /application-user/{username}/unlock instead.
     * @deprecated
     */
    async unlockUserLogin(requestParameters: UnlockUserLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlockUserLoginRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateApplicationUserRole1Raw(requestParameters: UpdateApplicationUserRole1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iEmployeeRoleUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iEmployeeRoleUpdateDto',
                'Required parameter "iEmployeeRoleUpdateDto" was null or undefined when calling updateApplicationUserRole1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/application-users/role`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IEmployeeRoleUpdateDtoToJSON(requestParameters['iEmployeeRoleUpdateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateApplicationUserRole1(requestParameters: UpdateApplicationUserRole1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateApplicationUserRole1Raw(requestParameters, initOverrides);
    }

    /**
     * Update OrganizationPropertiesStateConfig
     */
    async updateOrganizationPropertiesStateConfigRaw(requestParameters: UpdateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IOrganizationPropertiesStateConfigResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateOrganizationPropertiesStateConfig().'
            );
        }

        if (requestParameters['iOrganizationPropertiesStateConfigRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iOrganizationPropertiesStateConfigRequestDto',
                'Required parameter "iOrganizationPropertiesStateConfigRequestDto" was null or undefined when calling updateOrganizationPropertiesStateConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organization-properties-state-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IOrganizationPropertiesStateConfigRequestDtoToJSON(requestParameters['iOrganizationPropertiesStateConfigRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IOrganizationPropertiesStateConfigResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update OrganizationPropertiesStateConfig
     */
    async updateOrganizationPropertiesStateConfig(requestParameters: UpdateOrganizationPropertiesStateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IOrganizationPropertiesStateConfigResponseDto> {
        const response = await this.updateOrganizationPropertiesStateConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update role
     */
    async updateRoleRaw(requestParameters: UpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRoleResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRole().'
            );
        }

        if (requestParameters['iRoleUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iRoleUpdateDto',
                'Required parameter "iRoleUpdateDto" was null or undefined when calling updateRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/roles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IRoleUpdateDtoToJSON(requestParameters['iRoleUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRoleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update role
     */
    async updateRole(requestParameters: UpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRoleResponseDto> {
        const response = await this.updateRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async validatePasswordResetLinkRaw(requestParameters: ValidatePasswordResetLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPasswordResetLinkValidationResponseDto>> {
        if (requestParameters['linkId'] == null) {
            throw new runtime.RequiredError(
                'linkId',
                'Required parameter "linkId" was null or undefined when calling validatePasswordResetLink().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['linkId'] != null) {
            queryParameters['link_id'] = requestParameters['linkId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/password/reset/validation`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPasswordResetLinkValidationResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async validatePasswordResetLink(requestParameters: ValidatePasswordResetLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPasswordResetLinkValidationResponseDto> {
        const response = await this.validatePasswordResetLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyContactCodeRaw(requestParameters: VerifyContactCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>> {
        if (requestParameters['iCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCodeRequestDto',
                'Required parameter "iCodeRequestDto" was null or undefined when calling verifyContactCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/contacts/codes/verifications`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICodeRequestDtoToJSON(requestParameters['iCodeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInitiateAuthResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async verifyContactCode(requestParameters: VerifyContactCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto> {
        const response = await this.verifyContactCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyContactMfaCodeRaw(requestParameters: VerifyContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>> {
        if (requestParameters['iCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCodeRequestDto',
                'Required parameter "iCodeRequestDto" was null or undefined when calling verifyContactMfaCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/contacts/mfa/codes/verifications`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICodeRequestDtoToJSON(requestParameters['iCodeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInitiateAuthResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async verifyContactMfaCode(requestParameters: VerifyContactMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto> {
        const response = await this.verifyContactMfaCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyPersonMfaCodeRaw(requestParameters: VerifyPersonMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInitiateAuthResponseDto>> {
        if (requestParameters['iCodeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iCodeRequestDto',
                'Required parameter "iCodeRequestDto" was null or undefined when calling verifyPersonMfaCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['userAgent'] != null) {
            headerParameters['User-Agent'] = String(requestParameters['userAgent']);
        }


        let urlPath = `/mfa/codes/verifications`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICodeRequestDtoToJSON(requestParameters['iCodeRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInitiateAuthResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async verifyPersonMfaCode(requestParameters: VerifyPersonMfaCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInitiateAuthResponseDto> {
        const response = await this.verifyPersonMfaCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum SearchRolesByPagesLevelTypeEnum {
    ELEVATE = 'ELEVATE',
    GLOBAL = 'GLOBAL',
    PARTNER = 'PARTNER'
}
